import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export function LoginGate({ text = "Accedi per completare l'operazione." }) {
  return (
    <div data-testid="login-gate" className="flex items-center justify-between gap-3 rounded-2xl border border-cyan-200 bg-cyan-50 px-4 py-3">
      <p className="flex items-center gap-2 text-sm text-cyan-900"><Lock className="h-4 w-4" /> {text}</p>
      <Link data-testid="login-gate-link" to="/accedi?next=/" className="shrink-0 rounded-full bg-sky-600 px-4 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-sky-700">Accedi</Link>
    </div>
  );
}
